import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { useMemo } from "react";
import { mapBoundsAtom } from "@/lib/atoms/map.atoms";
import { trpc } from "@/router";
export function useMapPlaces() {
  const $ = _c(13);
  const bounds = useAtomValue(mapBoundsAtom);
  let t0;
  if ($[0] !== bounds) {
    t0 = trpc.map.placesByBoundingBox.queryOptions(bounds ? {
      minLat: bounds.minLat,
      minLng: bounds.minLng,
      maxLat: bounds.maxLat,
      maxLng: bounds.maxLng,
      limit: 200
    } : {
      minLat: 0,
      minLng: 0,
      maxLat: 0,
      maxLng: 0
    });
    $[0] = bounds;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = !!bounds;
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = {
      ...t0,
      enabled: t1,
      staleTime: 30000
    };
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data: places,
    isLoading,
    isFetching
  } = useQuery(t2);
  let t3;
  if ($[5] !== places) {
    t3 = places ?? [];
    $[5] = places;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = t3.map(_temp);
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const mapPlaces = t4;
  let t5;
  if ($[9] !== isFetching || $[10] !== isLoading || $[11] !== mapPlaces) {
    t5 = {
      places: mapPlaces,
      isLoading,
      isFetching
    };
    $[9] = isFetching;
    $[10] = isLoading;
    $[11] = mapPlaces;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
function _temp(p) {
  return {
    id: p.id,
    name: p.name,
    osmTags: p.osmTags,
    categoryName: p.categoryName ?? null,
    categoryIcon: p.categoryIcon ?? null,
    hasPendingFeature: p.hasPendingFeature,
    hasVerifiedFeature: p.hasVerifiedFeature,
    location: p.location
  };
}